import { create } from 'apisauce'
import loading from '@/store/loading'

const api = create({
    baseURL: `${process.env.VUE_APP_ASGI}/api/v2`,
})

api.axiosInstance.interceptors.request.use(config => {
    loading.commit('START_LOADING');
    return config
}, function (error) {
    loading.commit('FINISH_LOADING');
    return Promise.reject(error);
})

api.axiosInstance.interceptors.response.use(response => {
    loading.commit('FINISH_LOADING');
    return response;
}, function (error) {
    loading.commit('FINISH_LOADING');
    return Promise.reject(error);
});


// api.addRequestTransform(request => {
//     const token = localStorage.getItem('token')
//     if (token) {
//         request.headers['Authorization'] = `Token ${token}`
//     }
// })

export default api